import Table, {
  compareDates,
  compareStrings,
  createStringSearchFilter,
} from 'apollo-react/components/Table';
import React, { useLayoutEffect, useRef, useState } from 'react';

import ActionCell from './ActionCell';
import DateCell from '../../../components/CommonTableCells/DateCell';
import DatePickerFilter from '../../../components/TableFilters/DatePickerFilter';
import TextFieldFilter from '../../../components/TableFilters/TextInputFilter';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { createCustomDateFilter } from '../../../utils/formHistoryUtils';

const columns = [
  {
    header: 'Document Number',
    accessor: 'DOC_DOCUMENT_NO',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('DOC_DOCUMENT_NO'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Document Revision',
    accessor: 'DOC_DOCUMENT_REV',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('DOC_DOCUMENT_REV'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Title',
    accessor: 'DOC_TITLE',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('DOC_TITLE'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Type',
    accessor: 'DOT_TYPE',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('DOT_TYPE'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Effective Date',
    accessor: 'DOC_EFFECTIVE_DATE',
    sortFunction: compareDates,
    filterFunction: createCustomDateFilter('DOC_EFFECTIVE_DATE'),
    filterComponent: DatePickerFilter,
    customCell: DateCell,
  },
  {
    header: '',
    accessor: 'delete',
    width: 50,
    customCell: ActionCell,
  },
];

const AddedDocumentsTable = ({ selectedDocuments, setSelectedDocuments, duplicatedDocuments }) => {
  const translateString = useTranslation();

  const [page, setPage] = useState(0);

  const tableRef = useRef(null);

  useLayoutEffect(() => {
    if (tableRef.current) {
      const rows = tableRef.current?.querySelectorAll('tbody > tr') ?? [];
      rows.forEach((row) => {
        const docName = row.querySelectorAll('td')[0].textContent;
        if (duplicatedDocuments.some((doc) => doc.DBP_DOCUMENT_NO === docName)) {
          row.style.border = 'solid 1px #e20000';
        }
      });
    }
  }, [selectedDocuments, duplicatedDocuments, page]);

  return (
    <div ref={tableRef}>
      <Table
        title={translateString('Added Documents')}
        columns={columns.map((c) => ({ ...c, setSelectedDocuments }))}
        rows={selectedDocuments}
        emptyProps={{
          text: translateString('No data to display'),
        }}
        rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
        page={page}
        onChange={(values) => setPage(values.page)}
      />
    </div>
  );
};

export default AddedDocumentsTable;
